import React from "react";
import { Input } from "antd";

function AddModalView({ onExport, onClose, title }) {
  const onTemplateExport = (event) => {
    event?.preventDefault();
    const target = event?.currentTarget;
    const values = target?.acc1?.value;
    onExport(values, title);
  };

  const FormField = ({ labelString, type, placeholder, ...props }) => {
    return (
      <div className="flex flex-col w-full mb-4">
        <label className="mb-1 font-semibold text-gray-700">{labelString}</label>
        <Input type={type} placeholder={placeholder} required {...props} />
      </div>
    );
  };

  return (
    <div className="fixed inset-0 flex items-center justify-center bg-black bg-opacity-70 z-[100]">
      <form
        onSubmit={onTemplateExport}
        className="relative flex flex-col w-[560px] bg-gray-100 rounded-3xl shadow-xl p-6"
      >
        <button
          type="button"
          onClick={onClose}
          className="absolute top-4 right-4 h-10 w-24 bg-red-600 text-white font-bold rounded-full shadow-md hover:bg-red-700"
        >
          Close
        </button>

        <div className="flex flex-col items-center space-y-4 mt-10">
          <label className="text-2xl font-semibold text-center text-black">
            Add {title} dropdown collection
          </label>

          <FormField
            name="acc1"
            type="text"
            placeholder="Use commas to separate (e.g. Red, Blue, Green)"
            className="w-[540px] h-[120px] text-lg rounded-2xl bg-white shadow-md p-4 resize-none"
            style={{ minHeight: "120px" }}
          />

          <button
            type="submit"
            className="w-2/5 py-2 bg-blue-900 text-white font-semibold rounded-full hover:bg-blue-950"
          >
            Add to Collections
          </button>
        </div>
      </form>
    </div>
  );
}

export default AddModalView;
